import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

const ENTITY_KEYS = {
  bowler: {
    confirmKey: "message.confirm.confirmDeleteBowler",
    actionKey: "message.confirm.deleteBowler",
  },
  arsenal: {
    confirmKey: "message.confirm.confirmDeleteArsenal",
    actionKey: "message.confirm.deleteArsenal",
  },
  specsheet: {
    confirmKey: "message.confirm.confirmDeleteSpecSheet",
    actionKey: "message.confirm.deleteSpecSheet",
  },
  image: {
    confirmKey: "message.confirm.confirmDeleteImage",
    actionKey: "message.confirm.deleteImage",
  },
  video: {
    confirmKey: "message.confirm.confirmDeleteVideo",
    actionKey: "message.confirm.deleteVideo",
  },
};

const TitleBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing.sm};
  color: ${(p) =>
    p.$severity === "danger" ? p.theme.color.error : p.theme.color.warning};
  font-family: ${(p) => p.theme.font.family};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  font-size: ${(p) => p.theme.font.sizeMd};
`;

const Body = styled.div`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeMd};
  color: ${(p) => p.theme.color.text};
  text-align: center;
  line-height: 1.5;
`;

const ConfirmDialog = ({
  show,
  onHide,
  entity,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  severity = "danger",
}) => {
  const { t } = useTranslation();
  const keys = entity ? ENTITY_KEYS[entity] : null;
  const resolvedTitle = title || t("message.confirm.title");
  const resolvedDescription = description || (keys ? t(keys.confirmKey) : "");
  const resolvedConfirm =
    confirmText || (keys ? t(keys.actionKey) : t("feedback.common.confirm"));
  const resolvedCancel = cancelText || t("message.confirm.cancel");

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <TitleBar $severity={severity}>
          <ExclamationTriangleFill size={18} aria-hidden />
          <span>{resolvedTitle}</span>
        </TitleBar>
      </Modal.Header>
      <Modal.Body>
        <Body>{resolvedDescription}</Body>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          {resolvedCancel}
        </Button>
        <Button
          variant={severity === "danger" ? "danger" : "warning"}
          onClick={onConfirm}
        >
          {resolvedConfirm}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
